import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalImportSesssion  {
    _originalTypeClassName = "zERP.BO.GeneralJournalImportSesssion";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalImportSesssion.translate = translateService;
}
this.Type = null;
this.GeneralJournalImportSesssionKey = null;
this._key = this.GeneralJournalImportSesssionKey = 0; 
}

static translate: TranslateService;
_key: any;
Type:any;
Entity:any;
FiscalPeriod:any;
Currency:any;
private _GeneralJournalImportSesssionKey:any;
get GeneralJournalImportSesssionKey(): any {
    return this._GeneralJournalImportSesssionKey;
  }
set GeneralJournalImportSesssionKey(value: any) {
    this._GeneralJournalImportSesssionKey = value;
    this._key = value;
  }
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setCurrency = ($this, value) => {
var oldValue = $this.Currency;
$this.Currency = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalImportSesssionKey == null || $this.GeneralJournalImportSesssionKey == 0;
            }


}